// TestiMonials.jsx
import React, { useEffect, useRef, useState, useCallback } from "react";
import { motion } from "framer-motion";
import 'bootstrap-icons/font/bootstrap-icons.css';
import "../../styles/TestiMonials.css";
import img1 from "../../assets/avatar/1.jpeg"
import img2 from "../../assets/avatar/2.webp"
import img3 from "../../assets/avatar/4.jpeg"
import img4 from "../../assets/avatar/3.webp"

const TESTIMONIALS = [
  {
    id: 1,
    stars: 5,
    avatar: img2,
    quote:
      "City Woodworks transformed our living room with a custom TV unit. The design was modern, functional, and matched our home perfectly. The craftsmanship and finishing were top-notch!",
    author: "— Anitha R., Coimbatore",
    score: "4.82 Ratings",
  },
  {
    id: 2,
    stars: 5,
    avatar: img1,
    quote:
      "Our modular kitchen was beautifully executed by City Woodworks. They listened to our needs and delivered on time with impeccable quality. Highly recommend their service!",
    author: "— Ramesh K., Chennai",
    score: "4.9 Ratings",
  },
  {
    id: 3,
    stars: 5,
    avatar: img4,
    quote:
      "The team built a stunning custom wardrobe for our master bedroom. The finish is flawless and it fits perfectly with our décor.",
    author: "— Priya S., Bangalore",
    score: "4.85 Ratings",
  },
  {
    id: 4,
    stars: 5,
    avatar: img3,
    quote:
      "City Woodworks gave our office reception a sleek wooden counter that wows every visitor. Professional team and beautiful results!",
    author: "— Arjun M., Hyderabad",
    score: "4.95 Ratings",
  },
];

const StarRow = ({ count = 5 }) => (
  <div className="tmx-stars" aria-label={`${count} out of 5 stars`} role="img">
    {"★".repeat(count)}
  </div>
);


const Card = ({ t }) => {
  return (
    <motion.article
      className="tmx-card"
      whileHover={{ y: -6 }}
      whileTap={{ scale: 0.995 }}
      transition={{ type: "spring", stiffness: 300, damping: 24 }}
    >
      <div className="tmx-card-inner">
        <StarRow count={t.stars} />
        <div className="tmx-row">
          <div className="tmx-avatar" aria-hidden="true">
            <img src={t.avatar} alt="" loading="lazy" />
          </div>
          <blockquote className="tmx-quote">“{t.quote}”</blockquote>
        </div>
        <div className="tmx-meta">
          <span className="tmx-author">{t.author}</span>
          <div className="tmx-actions" aria-hidden="true">
            <button className="tmx-icon" aria-label="Like review">
              <i className="bi bi-heart-fill" />
            </button>
            <button className="tmx-icon" aria-label="Share review">
              <i className="bi bi-share-fill" />
            </button>
          </div>
        </div>
      </div>

      <div className="tmx-footer">
        <span className="tmx-score">{t.score}</span>
        <span className="tmx-stars-mini" aria-hidden="true">★★★★★</span>
      </div>
    </motion.article>
  );
};

const TestiMonials = () => {
  const [index, setIndex] = useState(0);
  const containerRef = useRef(null);

  // autoplay like reference
  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % TESTIMONIALS.length);
    }, 3500);
    return () => clearInterval(id);
  }, []);

  const prev = useCallback(() => setIndex((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length), []);
  const next = useCallback(() => setIndex((i) => (i + 1) % TESTIMONIALS.length), []);

  // keyboard
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [prev, next]);

  return (
    <section className="tmx-wrap" aria-labelledby="tmx-title">
      <div className="tmx-container">
        <header className="tmx-head">
          <h2 id="tmx-title" className="tmx-heading">Testimonials</h2>
          <p className="tmx-subtitle">Designer lofts to cozy cabins. Pick dates, pack bags, go.</p>
        </header>

        <div className="tmx-shell">
          {/* left sticky panel like reference */}
          <aside className="tmx-left">
            <div className="tmx-left-card">
              {/* <span className="tmx-quote-mark">“</span> */}
              {/* <p className="tmx-left-text">What are customers are saying</p> */}
            </div>
          </aside>

          {/* animated rail */}
          <div className="tmx-rail" ref={containerRef}>
            <div
              className="tmx-track"
              style={{ transform: `translateX(calc(${index} * -100%))` }}
            >
              {TESTIMONIALS.map((t) => (
                <Card key={t.id} t={t} />
              ))}
            </div>

            {/* nav arrows floating over rail */}
            <div className="tmx-arrows" role="group" aria-label="Testimonials navigation">
              <button className="tmx-nav" aria-label="Previous" onClick={prev}>←</button>
              <button className="tmx-nav" aria-label="Next" onClick={next}>→</button>
            </div>

            {/* dots */}
            <div className="tmx-dots" role="tablist" aria-label="Testimonials dots">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  className={`tmx-dot ${i === index ? "active" : ""}`}
                  onClick={() => setIndex(i)}
                  role="tab"
                  aria-selected={i === index}
                  aria-label={`Go to slide ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestiMonials;
